
import { of as observableOf } from 'rxjs';
import { filter, withLatestFrom, switchMap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { Http, RequestOptions } from '@angular/http';

import {
  INVALIDATE_PROFILE,
  REQUEST_PROFILE,
  RECEIVE_PROFILE,
  LOGOUT_USER,
  receiveProfile,
  requestProfile,
  setGuestUser, APPLY_AUTH, ADD_TAGS
} from './profile.actions';

import {
  NETWORK_ERROR, setShareCopyStatus, ShareCopyStatus
} from '../share/share.actions';

import { IAppState } from '../app.state';

import { normalize, schema } from 'normalizr';

import { Config } from '../universal-config';

const profile = new schema.Entity('profiles');

@Injectable()
export class ProfileEffects {
  url = '/profile/me';
  shareApiService;

  @Effect() invalidtateProfile$ = this.actions$.ofType(INVALIDATE_PROFILE).pipe(
    map(() => {
      return requestProfile();
    }),
  );

  @Effect() requestProfile$ = this.actions$
    .ofType<any>(REQUEST_PROFILE).pipe(
    withLatestFrom(this.store$),
    filter(([action, state]) => (state.profile.isInvalidated)),
    map(([action, state]) => action.payload),
    switchMap((action) => {
      return this.http.get(`${this.shareApiService}${this.url}`).pipe(
        catchError(() => observableOf(false)));
    }),
    map((response: any) => {
      const serverProfile = response && response.json()
      if (serverProfile) {
        return receiveProfile(normalize(response.json(), profile));
      } else {
        return setGuestUser();
      }
    }),
    catchError((err) => observableOf({ type: 'REQUEST_FAILED' })),);

  @Effect() logoutUser$ = this.actions$
    .ofType(LOGOUT_USER).pipe(
    switchMap((action) => {
      const logoutPath = this._config.get('AUTH_LOGOUT_PATH');
      const options = new RequestOptions({ withCredentials: true });
      return this.http.delete(logoutPath, options);
    }),
    map((response) => {
      this.store$.dispatch(setShareCopyStatus(ShareCopyStatus.SHARE_COPY_INITIAL))
      return { type: 'INVALIDATE_PROFILE' };
    }),
    catchError((response) => {
      return observableOf({ type: NETWORK_ERROR, code: response.status });
    }),);

  @Effect() applyAuth$ = this.actions$.ofType(APPLY_AUTH).pipe(
    switchMap((action: any) => {
      console.log('>>> FORM RESULT', action.formResult);
      return this.http.post('/share/apply-auth', action.formResult);
    }),
    map((apiResult) => {
      console.log('>>> API RESULT', apiResult);
      return { type: 'INVALIDATE_PROFILE' };
    }),
  );

  @Effect() addTags$ = this.actions$.ofType(ADD_TAGS).pipe(
    switchMap((action: any) => {
      return this.http.post(`${this.shareApiService}${this.url}/tags`, {tags: action.tags});
    }),
    map((apiResult) => {
      return {};
    }),
  );

  constructor(
    public actions$: Actions,
    public store$: Store<IAppState>,
    public http: Http,
    public _config: Config
  ) {
    this.shareApiService = _config.get('SHARE_API_SERVICE');
  }
}
